import axios, { AxiosResponse } from 'axios'
import {
  ContatoList,
  FornecedorDto,
  FornecedorEdicao,
  FornecedoresQueryResponse,
  FornecedorView,
  TIPO_CONTATO_FORNECEDOR,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
export const FORNECEDORES_URL = `${API_URL}/fornecedores`

/** Lista paginada; os filtros vão no `search` (ver `buscaFornecedores`). */
export const getFornecedores = (query: string): Promise<FornecedoresQueryResponse> =>
  axios
    .get(`${FORNECEDORES_URL}?${query}`)
    .then((resp: AxiosResponse<FornecedoresQueryResponse>) => resp.data)

/** Detalhe; a `logo` vem com URL pré-assinada de curta duração. */
export const getFornecedorById = (id: number): Promise<FornecedorView> =>
  axios.get(`${FORNECEDORES_URL}/${id}`).then((resp: AxiosResponse<FornecedorView>) => resp.data)

export const getContatosFornecedor = (id: number): Promise<ContatoList[]> =>
  axios
    .get(`${FORNECEDORES_URL}/${id}/contatos`)
    .then((resp: AxiosResponse<ContatoList[]>) => resp.data)

/** Detalhe mais o contato que o formulário edita (o do tipo Atendimento). */
export const getFornecedorEdicao = async (id: number): Promise<FornecedorEdicao> => {
  const [fornecedor, contatos] = await Promise.all([
    getFornecedorById(id),
    getContatosFornecedor(id),
  ])
  const contato = contatos.find((c) => c.tipoContato === TIPO_CONTATO_FORNECEDOR) ?? null
  return { ...fornecedor, contato }
}

export const createFornecedor = (dto: FornecedorDto): Promise<FornecedorView> =>
  axios.post(FORNECEDORES_URL, dto).then((resp: AxiosResponse<FornecedorView>) => resp.data)

export const updateFornecedor = (
  id: number,
  dto: Partial<FornecedorDto>
): Promise<FornecedorView> =>
  axios
    .put(`${FORNECEDORES_URL}/${id}`, { ...dto, id })
    .then((resp: AxiosResponse<FornecedorView>) => resp.data)

/** Envia a logo (multipart, campo `file`), no mesmo formato do upload de logo da empresa. */
export const updateFornecedorLogo = (id: number, file: File): Promise<FornecedorView> => {
  const formData = new FormData()
  formData.append('file', file)
  return axios
    .patch(`${FORNECEDORES_URL}/${id}/logo`, formData)
    .then((resp: AxiosResponse<FornecedorView>) => resp.data)
}

export const deleteFornecedorLogo = (id: number): Promise<void> =>
  axios.delete(`${FORNECEDORES_URL}/${id}/logo`).then(() => undefined)
